import { render, staticRenderFns } from "./Digital.vue?vue&type=template&id=90c854ec&"
import script from "./Digital.vue?vue&type=script&lang=js&"
export * from "./Digital.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports